import * as React from 'react';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import StreetAddress, { StreetAddressViewModel } from '../StreetAddress';

export type GuardianViewModel = {
    GuardianID: number;
    Relation: string;
    FirstName: string;
    LastName: string;
    MobilePhone: string;
    WorkName: string;
    WorkPhone: string;
    WorkPhoneExtension: string;
    WorkAddress: StreetAddressViewModel | null;
}

type Props = {
    Validation: boolean;
    guardian: GuardianViewModel;
    index: number;
    onChange: (newAddress: GuardianViewModel) => void;
}

export default class RegistrationGuardian extends React.Component<Props>{

    constructor(props: Props) {
        super(props);
    }

    public render() {
        return <React.Fragment>
            <h5>Guardian's Information</h5>
            <div className="card">
                <div className="card-body">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Relationship to Child<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <input
                            type="text"
                            placeholder="Parent, Guardian, etc"
                            className="form-control"
                            value={this.props.guardian.Relation}
                            onChange={(e) => this.updateGuardian({ Relation: e.target.value })}
                        />
                    </div>
                    {(this.props.Validation && !this.props.guardian.Relation) ? <p className="error-msg">Relationship is Required</p> : <br/>}
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Name<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <label id="name"></label>
                        <input
                            type="string"
                            name="FirstName"
                            placeholder="First Name"
                            className="form-control"
                            value={this.props.guardian.FirstName}
                            onChange={(e) => this.updateGuardian({ FirstName: e.target.value })}
                        />
                        <input
                            type="string"
                            name="LastName"
                            placeholder="Last Name"
                            className="form-control"
                            value={this.props.guardian.LastName}
                            onChange={(e) => this.updateGuardian({ LastName: e.target.value })}
                        />
                    </div>
                    {this.props.Validation && !this.props.guardian.FirstName && !this.props.guardian.LastName && <p className="error-msg">First and Last Name are Required</p>}
                    {this.props.Validation && !this.props.guardian.FirstName && this.props.guardian.LastName && <p className="error-msg">First Name is Required</p>}
                    {this.props.Validation && this.props.guardian.FirstName && !this.props.guardian.LastName && <p className="error-msg">Last Name is Required</p>}
                    {this.props.Validation && this.props.guardian.FirstName && this.props.guardian.LastName && <br/> || !this.props.Validation && <br/>}
                    <label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Cell Phone Number<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <MaskedTextBox
                                mask="(000)000-0000"
                                name="Phone"
                                placeholder="(000)000-0000"
                                value={this.props.guardian.MobilePhone || ''}
                                onChange={(e) => this.updateGuardian({ MobilePhone: e.target.value.replace(/_/g, "") })}
                            />
                        </div>
                    </label>
                    {(this.props.Validation && (!this.props.guardian.MobilePhone || this.props.guardian.MobilePhone.length < 13)) ? <p className="error-msg">Cell Phone is Required</p> : <br/>}
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Employer</span>
                        </div>
                        <input
                            type="text"
                            placeholder="Employer"
                            className="form-control"
                            value={this.props.guardian.WorkName}
                            onChange={(e) => this.updateGuardian({ WorkName: e.target.value })}
                        />
                    </div>
                    <br/>
                    <label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Work Phone Number</span>
                            </div>
                            <MaskedTextBox
                                mask="(000)000-0000"
                                name="Phone"
                                placeholder="(000)000-0000"
                                value={this.props.guardian.WorkPhone || ''}
                                onChange={(e) => this.updateGuardian({ WorkPhone: e.target.value})}
                            />
                            <input
                                type="text"
                                placeholder="Ext"
                                className="form-control"
                                maxLength={10}
                                value={this.props.guardian.WorkPhoneExtension}
                                onChange={(e) => this.updateGuardian({ WorkPhoneExtension: e.target.value })}
                            />
                        </div>
                    </label>
                    <br/>
                    <StreetAddress
                        address={this.props.guardian.WorkAddress}
                        onChange={(newAddress) => this.updateGuardian({ WorkAddress: newAddress })}
                        title="Work Address"
                        validation={this.props.Validation}
                        index={this.props.index}
                    />
                </div>
            </div>
            <br/>
        </React.Fragment>
    }

    private updateGuardian(value: Partial<GuardianViewModel>) {
        const newGuardian = Object.assign({}, this.props.guardian, value);
        this.props.onChange(newGuardian);
  }
}
